import styled from "styled-components";

const Wrapper = styled.div`
  color: initial;
  font-size: initial;
  font-family: initial;
`;

export default Wrapper;
